import qs from "qs";
import HttpRequest from "./request";

export class SkuProvider extends HttpRequest {
  constructor() {
    super(`${process.env.VUE_APP_SERVICE_GAME}/ams/api/sku`);
  }

  async getSku(params) {
    const queryString = qs.stringify(params, {
      addQueryPrefix: true,
    });

    const { data } = await this.get(`${queryString}`);
    return data;
  }

  async getById(id) {
    const { data } = await this.get(`/${id}`);
    return data;
  }

  async createSku(body) {
    const { data } = await this.create("", body);
    return data;
  }

  async editSku(id, body) {
    const { data } = await this.update(`/${id}`, body);
    return data;
  }
  async deleteSku(id) {
    const { data } = await this.delete(`/${id}`);
    return data;
  }
}
